import { render, staticRenderFns } from "./button-element.vue?vue&type=template&id=560c4ff3"
import script from "./button-element.vue?vue&type=script&lang=js"
export * from "./button-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports